import React, { Fragment, useState } from "react";

const TwoParticipantsVideo = () => {
  const [participantOneModal, setParticipantOneModal] = useState(false);
  const [participantTwoModal, setParticipantTwoModal] = useState(false);
  const [participantThreeModal, setParticipantThreeModal] = useState(false);
  const [participantFourModal, setParticipantFourModal] = useState(false);
  const [participantFiveModal, setParticipantFiveModal] = useState(false);
  const [participantSixModal, setParticipantSixModal] = useState(false);
  const [participantSevenModal, setParticipantSevenModal] = useState(false);
  const [participantEightModal, setParticipantEigthModal] = useState(false);

  return (
    <Fragment>
      <div className="live-stream-video-container grey">
        <div className="alt-video-overlay-light">
          <div className="discuss-content">
            <div class="user-overlay-info">
              <div class="streamer-user-avi"></div>
              <div className="streamer-user-info">
                <p className="streamer-item bold">User Name</p>
                <i
                  onClick={() => {
                    if (participantOneModal) {
                      setParticipantOneModal(false);
                    } else {
                      setParticipantOneModal(true);
                    }
                  }}
                  className="fas fa-ellipsis-v discussion-icon"
                ></i>
                {participantOneModal && (
                  <div className="modal">
                    <ul className="modal-items">
                      <li className="modal-item">
                        <i className="fas fa-flag mx-5 white"></i>
                        Report
                      </li>
                      <li className="modal-item">
                        <i className="fas fa-ban mx-5 white"></i>
                        Block
                      </li>
                    </ul>
                  </div>
                )}
              </div>
            </div>
            <div className="video-stream-live green">
              <i className="fas fa-circle mx-5"></i>
              Live
            </div>
            <div className="alt-left-items">
              <ul className="discuss-items">
                <li className="discuss-item white">
                  <i className="fas fa-vote-yea fa-2x cursor"></i>
                </li>
                <li className="discuss-item discuss-font green">3,541</li>
              </ul>
            </div>
            <div className="alt-right-items">
              <ul className="discuss-items">
                <li className="discuss-item discuss-time green">:30</li>
                <li className="discuss-item-mute green">
                  <i className="fas fa-volume-up fa-2x"></i>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <video
          src={
            "https://ime.sfo3.cdn.digitaloceanspaces.com/videos/20190628_141115.mp4"
          }
          className="fill-video"
        ></video>
      </div>
      <div className="live-stream-video-container grey">
        <div className="alt-video-overlay-dark">
          <div className="discuss-content">
            <div class="user-overlay-info">
              <div class="streamer-user-avi"></div>
              <div className="streamer-user-info">
                <p className="streamer-item bold">User Name</p>
                <i
                  onClick={() => {
                    if (participantTwoModal) {
                      setParticipantTwoModal(false);
                    } else {
                      setParticipantTwoModal(true);
                    }
                  }}
                  className="fas fa-ellipsis-v discussion-icon"
                ></i>
                {participantTwoModal && (
                  <div className="modal">
                    <ul className="modal-items">
                      <li className="modal-item">
                        <i className="fas fa-flag mx-5 white"></i>
                        Report
                      </li>
                      <li className="modal-item">
                        <i className="fas fa-ban mx-5 white"></i>
                        Block
                      </li>
                    </ul>
                  </div>
                )}
              </div>
            </div>
            <div className="video-stream-live-chat green">
              <i className="fas fa-circle mx-5"></i>
              Live
            </div>
            <div className="alt-left-items">
              <ul className="discuss-items">
                <li className="discuss-item white">
                  <i className="fas fa-vote-yea fa-2x cursor"></i>
                </li>
                <li className="discuss-item discuss-font green">3,541</li>
              </ul>
            </div>
            <div className="alt-right-items">
              <ul className="discuss-items">
                <li className="discuss-item discuss-time green">:30</li>
                <li className="discuss-item-mute green">
                  <i className="fas fa-volume-mute fa-2x"></i>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <video
          src={
            "https://ime.sfo3.cdn.digitaloceanspaces.com/videos/20190628_140936.mp4"
          }
          className="fill-video"
        ></video>
      </div>
    </Fragment>
  );
};

export default TwoParticipantsVideo;
